import { Box, HStack, Text, useColorMode, useRadio, useRadioGroup } from '@chakra-ui/react';
import { borderColor } from '../const';

interface ICustomSwitchProps {
	values: string[];
	handleChange: (type: string) => void;
	label: string;
	defaultValue: string;
}

export const CustomSwitch = ({ values, handleChange, label, defaultValue }: ICustomSwitchProps) => {
	const { colorMode } = useColorMode();

	const { getRootProps, getRadioProps } = useRadioGroup({
		name: label,
		defaultValue,
		onChange: type => handleChange(type)
	});

	const group = getRootProps();

	return (
		<Box
			border="1px"
			borderColor={borderColor[colorMode]}
			borderRadius="xs"
			p="5px"
			display="inline-block"
			mx="10px"
			my="5px"
		>
			<Text fontSize="sm"> {label} </Text>
			<HStack {...group}>
				mx="10px"
				{values.map(value => {
					const radio = getRadioProps({ value });
					return (
						<RadioCard key={value} {...radio}>
							{value}
						</RadioCard>
					);
				})}
			</HStack>
		</Box>
	);
};

const RadioCard = (props: any) => {
	const { getInputProps, getCheckboxProps } = useRadio(props);

	const input = getInputProps();
	const checkbox = getCheckboxProps();

	return (
		<Box as="label" fontSize={'sm'}>
			<input {...input} />
			<Box
				{...checkbox}
				cursor="pointer"
				borderWidth="1px"
				borderRadius="md"
				boxShadow="md"
				_checked={{
					bg: 'purple.600',
					color: 'white',
					borderColor: 'purple.700'
				}}
				_focus={{
					boxShadow: 'outline'
				}}
				px={5}
				py="5px"
			>
				{props.children}
			</Box>
		</Box>
	);
};
